function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  transform: "matrix(0.7071068 0.7071068 -0.7071068 0.7071068 35.35535 0)",
  id: "Rectangle-2",
  fill: "#D3D3D3",
  stroke: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 21C0 9.40202 9.62588 0 21.5 0C33.3741 0 43 9.40202 43 21C43 32.598 33.3741 42 21.5 42C9.62588 42 0 32.598 0 21Z",
  transform: "translate(14.35535 13.35535)",
  id: "Ellipse",
  fill: "#FFFFFF",
  stroke: "none"
});

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 71 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.df6a8e73.svg";
export { ForwardRef as ReactComponent };